module.exports = __webpack_public_path__ + "static/img/info-icon-2.1b8bf0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-icon-2.png
// module id = +4Kt
// module chunks = 5